import Big from 'big.js'
import moment from 'moment'
import { PerformanceHistory } from './interfaces'
import { Product } from '../../services/query-v2/products/index/product-info/model'
import { DailyStatistics } from '../../services/query-v2/products/index/daily-statistics/model'
import { assertMultiply } from 'utils'

export const roundUpToWholeNumber = (number: string): string => {
  if (number.startsWith('0.99')) {
    return Big(number).add(1).round(0, Big.roundDown).toString()
  } else {
    return Big(number).toFixed(2).toString()
  }
}

/**
 * Return the performance metrics of a product over time
 * @param product
 * @param dailyStats
 * @returns
 */
export const getPerformance = (
  product: Product,
  dailyStats: DailyStatistics,
): PerformanceHistory => {
  const now = moment().unix()
  const monthBefore = Math.floor(now - 2628000)
  const threeMonthBefore = Math.floor(now - 31536000 / 4)
  const firstDayOfTheYear = moment().startOf('year').unix()
  const yearBefore = Math.floor(now - 31536000)

  const performanceIntervalsTime = [
    monthBefore,
    threeMonthBefore,
    firstDayOfTheYear,
    yearBefore,
    now,
  ]
  const stats =
    dailyStats &&
    dailyStats.priceHistory.sort((a, b) => {
      if (a.date < b.date) return -1
      if (a.date > b.date) return 1
      return 0
    })
  const data =
    stats &&
    product &&
    performanceIntervalsTime.map((time, i) =>
      i === performanceIntervalsTime.length - 1
        ? stats
        : stats.filter((el) => moment(el.date).unix() >= time),
    )
  const perfArr = { ETH: [] as string[], USD: [] as string[] }

  data &&
    data.map((el) => {
      if (!product || !el[0] || !el[0].basePrice) {
        perfArr.USD.push('0')
      } else {
        assertMultiply(product.basePrice, 100)
        const usdValue = Big(product.basePrice).gt(0)
          ? `${Big(product.basePrice)
              .mul(100)
              .div(Big(el[0].basePrice))
              .minus(100)
              .round(2, 2)
              .toFixedSpecial(3)}`
          : '0'

        assertMultiply(product.basePriceETH, 100)

        const ethValue =
          Big(product.basePrice).gt(0) && Big(product.basePriceETH).gt(0)
            ? `${Big(product.basePriceETH)
                .mul(100)
                .div(Big(el[0].basePriceETH))
                .minus(100)
                .round(2, 2)
                .toFixedSpecial(3)}`
            : '0'

        perfArr.USD.push(usdValue as string)
        perfArr.ETH.push(ethValue as string)
      }
    })
  return perfArr
}
